import { render } from "./Withdraw.vue?vue&type=template&id=6dff5e67&scoped=true"
import script from "./Withdraw.vue?vue&type=script&lang=ts"
export * from "./Withdraw.vue?vue&type=script&lang=ts"

import "./Withdraw.vue?vue&type=style&index=0&id=6dff5e67&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dff5e67"

export default script